import { useEffect, useRef } from "react";

// Same behaviour as ui.js bindTips: any element with data-tip shows its HTML in the fixed #tip box.
export function Tip({ hideKey }) {
  const ref = useRef(null), cur = useRef(null);
  useEffect(() => {
    const tip = ref.current;
    const move = ev => {
      const x = Math.min(ev.clientX + 14, window.innerWidth - tip.offsetWidth - 8), y = Math.min(ev.clientY + 14, window.innerHeight - tip.offsetHeight - 8);
      tip.style.left = x + "px"; tip.style.top = y + "px";
    };
    const hide = () => { cur.current = null; tip.style.opacity = 0; };
    const over = ev => {
      const el = ev.target.closest && ev.target.closest("[data-tip]");
      if (!el || el === cur.current) return;
      cur.current = el; tip.innerHTML = el.getAttribute("data-tip"); tip.style.opacity = 1; move(ev);
    };
    const out = ev => {
      if (!cur.current) return;
      const to = ev.relatedTarget, nel = to && to.closest ? to.closest("[data-tip]") : null;
      if (!nel) hide();
    };
    const mm = ev => { if (cur.current) move(ev); };
    document.addEventListener("mouseover", over);
    document.addEventListener("mouseout", out);
    document.addEventListener("mousemove", mm);
    return () => { document.removeEventListener("mouseover", over); document.removeEventListener("mouseout", out); document.removeEventListener("mousemove", mm); };
  }, []);
  useEffect(() => { cur.current = null; if (ref.current) ref.current.style.opacity = 0; }, [hideKey]);
  return <div className="tip" id="tip" role="tooltip" ref={ref} data-testid="tooltip"></div>;
}
